import * as Styled from "./AddAttendeeButton.styles";
import { Typography } from "@mui/material";

type AddAttendeeButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  showIcon?: boolean;
  textColor?: string;
  textWeight?: number;
};

const AddAttendeeButton = ({
  onClick,
  disabled = false,
  showIcon = true,
  textColor = "black",
  textWeight = 400,
}: AddAttendeeButtonProps) => {
  return (
    <Styled.AddAttendeeContainer
      onClick={onClick}
      style={
        disabled
          ? {
              pointerEvents: "none",
              opacity: 0.5,
            }
          : {}
      }
    >
      {showIcon && <Styled.AddIcon />}
      <Typography style={{ color: textColor, fontWeight: textWeight }}>
        Add Attendee
      </Typography>
    </Styled.AddAttendeeContainer>
  );
};

export default AddAttendeeButton;
